<template>
  <TitleFrame text="旅行特性設定">
    <template slot="contents">
      <div class="mainContent">
        <p class="description">
          最適な情報を提供するため、今回の旅行について教えてください。
        </p>
        <SelectBoxArea
          text="宿泊・日帰り"
          :item-list="syukuhakuList"
          :initialValue="selected.syukuhaku"
          @change-value="changeSyuhaku"
        />
        <SelectBoxArea
          text="帰宅予定時間"
          :item-list="kitakuList"
          :initialValue="selected.kitaku"
          @change-value="changeKitaku"
        />
        <SelectBoxArea
          text="同伴者（自分を除く）"
          :item-list="fellowNumberList"
          :initialValue="selected.fellowNumber"
          @change-value="changeFellowNumberList"
        />
        <SelectBoxArea
          text="同伴者の構成"
          :item-list="fellowList"
          :initialValue="selected.fellow"
          @change-value="changeFellow"
        />
        <SelectBoxArea
          text="山梨県への訪問回数"
          :item-list="yamanashiVisitNumber"
          :initialValue="selected.yamanashiVistNumber"
          @change-value="changeYamanashi"
        />
        <div class="ngWrapper">
          <p class="ng" v-if="!isValidationOk">未設定項目があります</p>
        </div>
        <div class="buttons">
          <ButtonTextLink
            v-if="registrationData.lastReasearchAnswer"
            class="button"
            text="変更なし"
            @click-text="onSubmit"
          />
          <ButtonTextLink
            class="button"
            :text="
              registrationData.lastReasearchAnswer ? '設定更新' : '設定する'
            "
            :disable="!isValidationOk"
            @click-text="onSubmit"
          />
        </div>
      </div>
    </template>
  </TitleFrame>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
  SYUKUHAKU_LIST,
  KITAKU_LIST,
  FELLOW_NUMBER_LIST,
  FELLOW_LIST,
  YAMANASHI_VISIT_NUMBER,
} from "../../const.js";
import TitleFrame from "@/components/Templates/TitleFrame";
import Firebase from "./../../firebase";
import SelectBoxArea from "@/components/Atoms/SelectBoxArea";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";

export default {
  name: "research",
  components: {
    TitleFrame,
    SelectBoxArea,
    ButtonTextLink,
  },
  computed: {
    ...mapState(["answers", "registrationData"]),
    syukuhakuList() {
      return SYUKUHAKU_LIST;
    },
    kitakuList() {
      return KITAKU_LIST;
    },
    fellowNumberList() {
      return FELLOW_NUMBER_LIST;
    },
    fellowList() {
      return FELLOW_LIST;
    },
    yamanashiVisitNumber() {
      return YAMANASHI_VISIT_NUMBER;
    },
    isFellow() {
      return (
        this.selected.fellowNumber === "1人" && this.selected.fellow === ""
      );
    },
    isValidationOk() {
      return (
        this.selected.syukuhaku !== "" &&
        this.selected.kitaku !== "" &&
        this.selected.fellow !== "" &&
        this.selected.fellowNumber !== "" &&
        this.selected.yamanashiVistNumber !== ""
      );
    },
  },
  data() {
    return {
      selected: {
        syukuhaku: "",
        kitaku: "",
        fellowNumber: "",
        fellow: "",
        yamanashiVistNumber: "",
      },
    };
  },
  methods: {
    ...mapMutations(["loadingStartMini", "loadingEndMini"]),
    changeSyuhaku(e) {
      this.selected.syukuhaku = e.ans;
    },
    changeKitaku(e) {
      this.selected.kitaku = e.ans;
    },
    changeFellowNumberList(e) {
      this.selected.fellowNumber = e.ans;
    },
    changeFellow(e) {
      this.selected.fellow = e.ans;
    },
    changeYamanashi(e) {
      this.selected.yamanashiVistNumber = e.ans;
    },
    onSubmit() {
      this.loadingStartMini();
      Firebase.putUserResearch(this.selected);
      this.loadingEndMini();
      this.$router.push({ name: "Main" });
    },
  },
  async beforeMount() {
    this.selected = { ...this.selected, ...this.answers };
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.mainContent {
  padding: 1rem 1rem;
}
.description {
  margin-bottom: 1rem;
}

p {
  margin: 0;
}
.buttons {
  display: flex;
  gap: 1rem;
  .button {
    width: 100%;
  }
}
.ngWrapper {
  margin: 1rem 0 0;
  height: 0.75rem;
  .ng {
    color: #ff7c86;
    font-size: 0.75rem;
    line-height: 1;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Research.vue